import React from 'react';
import { Box, Container, Typography, Grid, CardMedia, useMediaQuery, useTheme, } from '@mui/material';
import img1 from './img/usecaseImg1.png';
import img2 from './img/usecaseImg2.png';
import img3 from './img/usecaseImg3.png';
import img4 from './img/usecaseImg4.png';
import img5 from './img/usecaseImg5.png';
import img6 from './img/usecaseImg6.png';

const UseCaseSection = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const renderSection = (title, description, bullets, image, imageLeft = false) => (
        <Grid container spacing={4} alignItems="center" direction={isMobile ? 'column' : 'row'}>
            {imageLeft && !isMobile && (
                <Grid item xs={12} md={5}>
                    <CardMedia
                        component="img"
                        image={image}
                        alt={title}
                        sx={{
                            width: '100%',
                            height: 'auto',
                            objectFit: 'cover',
                            borderRadius: 2,
                        }}
                    />
                </Grid>
            )}

            <Grid item xs={12} md={7}>
                <Typography
                    variant="h5"
                    fontWeight="bold"
                    sx={{ mb: 2, fontSize: { xs: '22px', md: '26px' }, textAlign: { xs: 'center', md: 'left' } }}
                >
                    {title}
                </Typography>

                {description.map((text, index) => (
                    <Typography
                        key={index}
                        variant="body1"
                        color="text.secondary"
                        sx={{ mb: 1, fontSize: { xs: '16px', md: '20px' }, textAlign: { xs: 'center', md: 'left' } }}
                    >
                        {text}
                    </Typography>
                ))}

                {bullets && (
                    <Box
                        component="ul"
                        sx={{
                            pl: 3,
                            color: 'text.secondary',
                            fontSize: { xs: '16px', md: '20px' },
                            fontFamily: (theme) => theme.typography.fontFamily,
                            textAlign: { xs: 'left', md: 'left' },
                        }}
                    >
                        {bullets.map((item, i) => (
                            <li key={i}>{item}</li>
                        ))}
                    </Box>
                )}
            </Grid>

            {!imageLeft || isMobile ? (
                <Grid item xs={12} md={5}>
                    <CardMedia
                        component="img"
                        image={image}
                        alt={title}
                        sx={{
                            width: '100%',
                            height: 'auto',
                            objectFit: 'cover',
                            borderRadius: 2,
                            mt: { xs: 2, md: 0 },
                        }}
                    />
                </Grid>
            ) : null}
        </Grid>
    );

    return (
        <Box
            sx={{
                backgroundImage: `url('bg2.svg')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                py: { xs: 6, md: 10 },
            }}
        >
            <Container maxWidth="lg">
                {/* Heading */}
                <Typography
                    variant="h3"
                    fontWeight="bold"
                    align="center"
                    sx={{ mb: 2, fontSize: { xs: '32px', md: '48px' } }}
                >
                    WhatsApp Forms Unique Use Cases
                </Typography>
                <Typography
                    variant="subtitle1"
                    align="center"
                    color="text.secondary"
                    sx={{ mb: 6, fontSize: { xs: '18px', md: '22px' } }}
                >
                    Check out multiple ways you can use WhatsApp forms for your business...
                </Typography>

                {/* Section 1 */}
                {renderSection(
                    'Streamline Lead Qualification & Data Collection',
                    [
                        'Guide users through a well-designed flow to qualify leads and capture crucial information.',
                        'Effortlessly collect valuable user information without real-time communication. Ideal for businesses of all sizes.',
                    ],
                    null,
                    img1
                )}

                <Box mt={{ xs: 8, md: 10 }} />

                {/* Section 2 */}
                {renderSection(
                    'Conduct Surveys & collect feedback directly within WhatsApp',
                    [
                        'Use WhatsApp Forms to conduct surveys seamlessly. Collect feedback, preferences, or opinions from your audience.',
                        'This simplifies data collection and enables you to gather insights in a user-friendly way.',
                    ],
                    null,
                    img2,
                    true
                )}

                <Box mt={{ xs: 8, md: 10 }} />

                {/* Section 3 */}
                {renderSection(
                    'Seamlessly process Loan Applications',
                    [
                        'WhatsApp Forms is a great way to process loan applications, offering a smooth, user-friendly experience.',
                        'Fintech Businesses can use these forms to:',
                    ],
                    [
                        'Display pre-approved loan amounts with customizable terms like repayment periods.',
                        'Allow users to choose disbursement and payment methods.',
                        'Authenticate user identity for secure applications.',
                        'Perfect for pre-approved loans, credit card offers, loan calculatorsand more.',
                    ],
                    img3
                )}

                <Box mt={{ xs: 8, md: 10 }} />

                {/* Section 4 */}
                {renderSection(
                    'Simplify Insurance sales',
                    ['Businesses can create WhatsApp forms to:'],
                    [
                        'Collect user preferences (e.g., members covered, health risks, premium amounts).',
                        'Offer personalised insurance quotes based on the user’s inputs.',
                        'Enable users to customise and select their ideal plan.',
                        'Excellent for quotes, renewalsand onboarding.',
                    ],
                    img4,
                    true
                )}

                <Box mt={{ xs: 8, md: 10 }} />

                {/* Section 5 */}
                {renderSection(
                    'Collect Purchase Intent',
                    [
                        'Understand what your customers want by using WhatsApp Forms to gather purchase intent.',
                        'Using WhatsApp forms, you can:',
                    ],
                    [
                        'Collect customer data, such as name and contact details.',
                        'Allow users to indicate their interests in specific products or services.',
                        'Use this data to create targeted sales campaigns and personalized promotions.',
                    ],
                    img5
                )}

                <Box mt={{ xs: 8, md: 10 }} />

                {/* Section 6 */}
                {renderSection(
                    'Drive conversions with Personalized Offers',
                    [
                        'Help users reach purchase decisions easily with tailored offers via WhatsApp Forms.',
                        'Automate reminders and promotions based on user behavior.',
                    ],
                    null,
                    img6,
                    true
                )}
            </Container>
        </Box>
    );
};

export default UseCaseSection;
